export default __webpack_public_path__ + "static/media/deactivate-user.8eb0b373.svg";